import { NgModule } from '@angular/core';
import { CacheGetService } from './cache-get.service';

@NgModule({
  providers: [CacheGetService],
  imports: [],
})
export class CacheGetServiceModule {}
